import { Banner, Button, Flex } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

type ADPConsentRequiredBannerProps = {
  adpConsentRedirectURL: string;
};

const ADPConsentRequiredBanner = ({
  adpConsentRedirectURL,
}: ADPConsentRequiredBannerProps) => {
  const { t } = useTranslation('common');

  return (
    <Flex m="3rem">
      <Banner
        id="adp-consent-banner"
        intent="warning"
        width="100%"
        title={t('adpConsentRequiredBanner.title')}
        message={t('adpConsentRequiredBanner.message')}
        cta={
          <Button
            id="adp-consent-link"
            variant="text"
            intent="warning"
            onClick={() => (window.location.href = adpConsentRedirectURL)}>
            {t('adpConsentRequiredBanner.ctaButton')}
          </Button>
        }
      />
    </Flex>
  );
};

export default ADPConsentRequiredBanner;
